import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Button, Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import FilterAdmin from "../../components/FilterAdmin/FilterAdmin";
import CustomDatatable from "../../components/CustomDatatable/CustomDatatable";
import renderFormatedDate from "../../components/RenderCellsDatatable/renderFormatterDate";
import { changePageSizeTemplate, cleanMessageTemplate, getListaTemplate, getTemplateHistoryList } from "../../store/actions";
import { connect } from "react-redux";
import renderHeader from "../../components/RenderCellsDatatable/renderHeader";
import renderBoolean from "../../components/RenderCellsDatatable/renderBoolean";
import { useIsFirstRender } from "../../customHooks/useIsFirstRender";

import HistoryModal from "../../components/HistoryModal/HistoryModal";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useContextActions } from "../../customHooks/useContextActions";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import { PAGE_SIZE_OPTIONS } from "../../constants/pagination";

const TemplateList = ({
	listaTemplate,
	loadingTemplate,
	getListaTemplateRequest,
	getTemplateHistoryList,
	loadingTemplateHistory,
	listaTemplateHistory,
	messageTemplate, 
	cleanMessageTemplate,
	errorLoadingTemplateHistory,
	pageSizeTemplate,
	changePageSizeTemplate,
}) => {
	const [objFilter, setObjFilter] = useState({
		createDateStart: null,
		updateDateStart: null,
		createDateEnd: null,
		updateDateEnd: null,
		createUser: null,
		updateUser: null,
		status: true, 
	});
	const isFirstRender = useIsFirstRender();
	const navigate = useNavigate();
	const alertModal = withReactContent(Swal);
	const [paginationModel, setPaginationModel] = useState({
		pageSize: pageSizeTemplate,
		page: 0,
	})

	const [currentPageHistory, setCurrentPageHistory] = useState(1);
	const [idCurrentTemplateHistory, setIdCurrentTemplateHistory] = useState(null);
	const pageSizeHistory = 10;
	const totalPagesHistory = Math.ceil(
		(listaTemplateHistory?.totalRecords || 0) / pageSizeHistory
	);
	const handlePageChangeHistory = (page) => {
		if (!idCurrentTemplateHistory) return;
		if (page < 1 || page > totalPagesHistory) return;
		setCurrentPageHistory(page);
	
		getTemplateHistoryList({
		  templateId: idCurrentTemplateHistory,
		  page,
		});
	}
	
	const fetchTemplateHistory = (templateId) => {
		getTemplateHistoryList({ templateId, page: 1 });
	}
	const handleDetailTemplateHistory = (item) => {
		window.open(`/template?idHistory=${item.idHistory}`, "_blank");
	}
	const columns = [
	{
		field: "title",
		headerName: "Title",
		flex: 1,
		sortable: false,
		renderHeader: renderHeader,
	},
	{
		field: "description",
		headerName: "Description",
		flex: 1,
		sortable: false,
		renderHeader: renderHeader,
	},
	{
		field: "active",
		headerName: "Active Status",
		flex: 1,
		sortable: false,
		renderHeader: renderHeader,
		renderCell: renderBoolean,
		type: "boolean",
	},
	{
		field: "createDate",
		headerName: "Creation Date",
		flex: 1,
		sortable: false,
		renderHeader: renderHeader,
		renderCell: renderFormatedDate,
	},
	{
		field: "updateDate",
		headerName: "Update Date",
		flex: 1,
		sortable: false,
		renderHeader: renderHeader,
		renderCell: renderFormatedDate,
	},
	{
		field: "id",
		headerName: "History",
		flex: 1,
		renderCell: (params) => (
			<HistoryModal 
				trigger={
					<Button color="" style={{ width: 50, height: 50 }}>
						<i className="fas fa-history"></i>
					</Button>
				}
				fetchHistory={() => {
					fetchTemplateHistory(params.value)
					setCurrentPageHistory(1);
					setIdCurrentTemplateHistory(params.value);
				}}
				loading={loadingTemplateHistory}
				data={listaTemplateHistory?.records}
				onDetail={handleDetailTemplateHistory}
				errorLoadingHistory={errorLoadingTemplateHistory}

				handlePageChange={handlePageChangeHistory}
				totalPages={totalPagesHistory}
				currentPage={currentPageHistory}
				
				columns={[
				{
					key: "updateDate",
					render: (item) =>
						moment(item.updateDate === null ? item.createDate : item.updateDate).format("DD MMM/YY hh:mm A"),
				},
				{ key: "title" },
				{ key: "updateUser",
					render: (item) =>
						item.updateUser === null ? item.createUser : item.updateUser,
				 },
          ]}
			/>
		),
		sortable: false,
		renderHeader: renderHeader,
	  },
	]

	const handlePageChange = (model) => {
    const { page, pageSize } = model;
    setPaginationModel({
      pageSize: pageSize,
      page: page,
    });
    changePageSizeTemplate(pageSize)

    getListaTemplateRequest({
      pageNumber: page + 1,
      pageSize: pageSize,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      createUser: objFilter.createUser,
      updateUser: objFilter.updateUser,
      status: objFilter.status,
      title: objFilter.search,
    });

  };
	const handleSortChange = (model) => {
		console.log(model);
		setTimeout(() => {
			//
		}, 300);
	};
	const handleRowClick = (params, event) => {
		navigate(`/template?id=${params.id}`);
	};

	const actions = useContextActions({
		context: "template",
		screen: "list",
	})

	useEffect(() => {
		setPaginationModel(prev => ({
			...prev,
			page: 0
		}));
		getListaTemplateRequest({
			pageNumber: 1,
			pageSize: paginationModel.pageSize,
			createDateStart: objFilter.createDateStart,
			updateDateStart: objFilter.updateDateStart,
			createDateEnd: objFilter.createDateEnd,
			updateDateEnd: objFilter.updateDateEnd,
			createUser: objFilter.createUser,
			updateUser: objFilter.updateUser,
			status: objFilter.status,
			title: objFilter.search,
		})
		// eslint-disable-next-line
	}, [objFilter]);
	useEffect(() => {
		if (messageTemplate) {
			alertModal
				.fire({
					title: `${
						messageTemplate !== null
							? messageTemplate
							: "Something wrong, try again later."
					}`,
					icon: "error",
					showConfirmButton: false,
					timer: undefined,
					showCloseButton: true,
					timerProgressBar: false,
				})
				.then(() => {
					cleanMessageTemplate();
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [messageTemplate]);
	useEffect(() => {
		return () => {
			cleanMessageTemplate();
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="page-content">
			<Helmet>
				<title>Templates</title>
			</Helmet>
			<Container fluid>
				<Row>
					<Col md={12}>
						<Card>
							<CardBody>
								<div>
									<Row>
										<div className="d-flex justify-content-between my-2">
											<h2>TEMPLATE</h2>
											<ActionButtons 
												actions={actions}
												context="template"
												handlers={{
													create: () => navigate("/template")
												}}
											/>
										</div>
										<FilterAdmin
											setObjFilter={setObjFilter}
											placeholderSearch={"Search by template title"}
											isFistRender={isFirstRender}
										/>

										<Row className="my-2">
											{loadingTemplate ? (
												<div
													className="d-flex align-items-center justify-content-center"
													style={{ height: "400px", width: "100%" }}
												>
													<Spinner
														color="primary"
														style={{ height: "5rem", width: "5rem" }}
													/>
												</div>
											) : (
												<>
												<CustomDatatable
													columns={columns}
													rows={listaTemplate.records}
													rowCount={listaTemplate.totalRecords}
													pagination
													paginationMode="server"
													paginationModel={paginationModel}
													onPaginationModelChange={handlePageChange}
													onSortModelChange={handleSortChange}
													onRowClick={handleRowClick}
													pageSizeOptions={PAGE_SIZE_OPTIONS}
													checkboxSelection={false}
													disableColumnFilter
													disableColumnMenu
												/>
											</>
											)}
										</Row>
									</Row>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		</div>
	)
}



const mapStateToProps = ({
	TemplateReducer: { loadingTemplate, listaTemplate, loadingTemplateHistory, listaTemplateHistory, messageTemplate, errorLoadingTemplateHistory, pageSizeTemplate },
}) => ({
	loadingTemplate,
	listaTemplate,
	loadingTemplateHistory,
	listaTemplateHistory,
	messageTemplate,
	errorLoadingTemplateHistory,
	pageSizeTemplate,
})

const mapDispatchToProps = {
	getListaTemplateRequest: getListaTemplate.request,
	getTemplateHistoryList: getTemplateHistoryList.request,
	cleanMessageTemplate,
	changePageSizeTemplate,
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplateList);